import HomepageCarousel from "./HomepageCarousel";
import React from 'react';
import styled, {useTheme} from "styled-components";
import themeResponsiveProperty from "../responsive/themeResponsiveProperty";
import {useEffect, useState} from "react";
import HomeStoreActions from "../../flux/HomeStoreActions";
import HomeStore from "../../flux/HomeStore";
import NoResults from "../NoResults";
import __ from "../../utils/translator";
import PageTitle from "../PageTitle";

export default function HomepageToCompleteList() {
  const appTheme = useTheme();
  const [toCompleteData, setToCompleteData] = useState(null);

  const onFetchCompleted = () => {
    const {data} = HomeStore.getState();
    setToCompleteData(data);
  }

  useEffect(() => {
    HomeStoreActions.fetchToComplete();
    const subscription = HomeStore.addListener(onFetchCompleted)
    return () => {
      subscription.remove();
    };
  }, []);

  if (toCompleteData === null) {
    return null;
  }

  return (
    <Container>
      <PageTitle withTracking title="Home / To complete" />

      {toCompleteData.every((carousel) => (carousel.length === 0)) ? (
        <NoResults
          message={__('No items found')}
          tip={__('Try again later')}
        />
      ) : (
        toCompleteData.filter((carousel) => carousel.length > 0).map((carousel, i) => (
          <HomepageCarousel
            fullscreen={i === 0 && appTheme.isTablet}
            key={carousel[0].typology}
            elements={carousel}
          />
        ))
      )}
    </Container>
  )
}

const Container = styled.div`
  margin-top: ${themeResponsiveProperty(".5rem", "1.5rem")};
`
